module.exports = __webpack_public_path__ + "static/media/logo856927f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 1221
// module chunks = 0